var React = require('react');

function Restaurant (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"restaurant"),React.createElement("path",{"d":"M15.984 6q0-1.406 1.523-2.695t3.492-1.289v19.969h-2.484v-7.969h-2.531v-8.016zM11.016 9v-6.984h1.969v6.984q0 1.594-1.078 2.742t-2.672 1.242v9h-2.484v-9q-1.594-0.094-2.672-1.242t-1.078-2.742v-6.984h2.016v6.984h1.969v-6.984h2.016v6.984h2.016z","key":1})]);
}

Restaurant.defaultProps = {"version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Restaurant;

Restaurant.default = Restaurant;
